// #region imports

// --- Angular
import {
  Component,
  OnInit,
  ViewContainerRef,
  ViewChild,
  EmbeddedViewRef,
  AfterViewInit,
  OnDestroy,
  TemplateRef,
  Input,
  ElementRef
} from '@angular/core';

// #endregion


@Component({
  selector: 'hs-portal',
  templateUrl: './portal.component.html',
  styleUrls: ['./portal.component.scss']
})
export class PortalComponent {
  @Input() selector: string = '';

  @ViewChild('portal', { static: false }) portalActionsTmplRef: TemplateRef<{}> | undefined;
  private _disposeFn: () => void = () => {};
  private _viewRef: EmbeddedViewRef<{}> | undefined;

  constructor(private viewContainerRef: ViewContainerRef) { }

  ngAfterViewInit() {

    // render the view
    if (this.portalActionsTmplRef) {
      this._viewRef = this.viewContainerRef.createEmbeddedView(
        this.portalActionsTmplRef
      );
      this._viewRef.detectChanges();

      // grab the DOM element
      const outletElement = document.querySelector(this.selector);

      // attach the view to the DOM element that matches our selector
      if (outletElement) {
        this._viewRef.rootNodes.forEach((rootNode) => {
          outletElement.appendChild(rootNode);
        });
      }
    }

    // register a dispose fn we can call later
    // to remove the content from the DOM again
    this._disposeFn = () => {};
  }

  ngOnDestroy() {
    if (this._viewRef) {
      const index = this.viewContainerRef.indexOf(this._viewRef);
      if (index !== -1) {
        this.viewContainerRef.remove(index);
      }
    }
  }
}
